import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import SocialSidebar from '../components/layout/SocialSidebar';
import HeroSection from '../components/home/HeroSection';
import ExpertiseSection from '../components/home/ExpertiseSection';
import NewsSection from '../components/home/NewsSection';
import ContactSection from '../components/home/ContactSection';
import ScrollReveal from '../components/ui/ScrollReveal';
import { companyInfo } from '../data/mockData';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>{companyInfo.name} - {companyInfo.slogan}</title>
        <meta name="description" content={`${companyInfo.name} is a leading non-bank financial institution in Sri Lanka, providing comprehensive financial solutions including leasing, loans, and gold loans.`} />
        <meta property="og:title" content={`${companyInfo.name} - ${companyInfo.slogan}`} />
        <meta property="og:description" content="Your trusted partner for leasing, loans, and gold loan solutions in Sri Lanka." />
        <meta property="og:type" content="website" />
        <meta name="keywords" content="leasing, loans, gold loan, auto loan, Sri Lanka, finance company" />
      </Helmet>
      <Header />
      <SocialSidebar />
      <main>
        {/* Hero loads immediately - above the fold */}
        <HeroSection />

        {/* Below-the-fold sections with scroll reveal */}
        <ScrollReveal animation="fade-up" delay={0} threshold={0.15}>
          <ExpertiseSection />
        </ScrollReveal>

        <ScrollReveal animation="fade-up" delay={100} threshold={0.1}>
          <NewsSection />
        </ScrollReveal>

        <ScrollReveal animation="fade-up" delay={100} threshold={0.1}>
          <ContactSection />
        </ScrollReveal>
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
